import React, { Component } from 'react';
import './css/extracurr.css' ;

class Extracurr extends Component{

    constructor(props){
        super(props)
        this.state = {}
    }


    render(){
        return (
            <div className='extracurrContainer'>
                <div id = "certifications">
                    <h1> Will be updated soon... </h1>
                </div>
            </div>
        )
    }

}

export default Extracurr;